// apps/blend-food/src/app/app.routes.ts
import { Route } from '@angular/router';
import { authGuard, publicOnlyGuard } from '@cardapio-online/auth';
import { NotFoundComponent, ShellLayoutAdminComponent, ShellLayoutComponent } from '@cardapio-online/shell';

export const appRoutes: Route[] =  [
  {
    path: 'login',
    canActivate: [publicOnlyGuard],
    loadChildren: () =>
      import('@cardapio-online/login').then((m) => m.LoginModule),
  },
{
  path: 'admin',
  component: ShellLayoutAdminComponent,
  canActivate: [authGuard],
children: [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  {
    path: 'dashboard',
    data: {
      nav: {
        label: 'Dashboard',
        badge: '🖥️',
        order: 1,
        showInMenu: false,
        licenseKey: 'dashboard',
      },
    },
    loadChildren: () =>
      import('@cardapio-online/dashboard').then((m) => m.DashboardModule),
  },
  {
    path: 'Empresa',
    data: {
      nav: {
        label: 'Empresa',
        badge: '🏢',
        order: 2,
        showInMenu: true,
        licenseKey: 'company',
      },
    },
    loadChildren: () =>
      import('@cardapio-online/company').then((m) => m.CompanyModule),
  },
  {
    path: 'produtos',
    data: {
      nav: {
        label: 'Produtos',
        badge: '🍔',
        order: 3,
        showInMenu: true,
        licenseKey: 'products',
      },
    },
    loadChildren: () =>
      import('@cardapio-online/products-admin').then((m) => m.ProductsAdminModule),
  },
  {
    path: 'categorias',
    data: {
      nav: {
        label: 'Categorias',
        badge: '🗂',
        order: 4,
        showInMenu: true,
        licenseKey: 'categories',
      },
    },
    loadChildren: () =>
      import('@cardapio-online/categories').then((m) => m.CategoriesModule),
  },
  {
     path: 'imagens',
  data: {
    nav: {
      label: 'Imagens',
      badge: '🖼️',
      order: 5,
      showInMenu: true,
      licenseKey: 'images',
      
    },
  },
   loadChildren: () =>
      import('@cardapio-online/images').then((m) => m.ImagesModule),
  },
  {
     path: 'pedidos',
  data: {
    nav: {
      label: 'Pedidos',
      badge: '🔔',
      order: 6,
      showInMenu: true,
      licenseKey: 'orders',
      
    },
  },
   loadChildren: () =>
      import('@cardapio-online/orders').then((m) => m.OrdersModule),
  },
  {
     path: 'vitrine',
  data: {
    nav: {
      label: 'Vitrine',
      badge: '🏪',
      order: 7,
      showInMenu: true,
      licenseKey: 'showcase',
      
    },
  },
   loadChildren: () =>
      import('@cardapio-online/showcases').then((m) => m.ShowcasesModule),
  },
  {
     path: 'extras',
  data: {
    nav: {
      label: 'Adicionais',
      badge: '➕',
      order: 8,
      showInMenu: true,
      licenseKey: 'extras',
      
    },
  },
   loadChildren: () =>
      import('@cardapio-online/extras').then((m) => m.ExtrasModule),
  },
  {
     path: 'entregas',
  data: {
    nav: {
      label: 'Taxa de Envio',
      badge: '🏍',
      order: 9,
      showInMenu: true,
      licenseKey: 'delivery',

    },
  },
   loadChildren: () =>
      import('@cardapio-online/delivery-admin').then((m) => m.DeliveryAdminModule),
  },
  {
    path: 'financial',
    data: {
      nav: {
        label: 'Financeiro',
        badge: '💲',
        order: 10,
        showInMenu: true,
        licenseKey: 'financial',
      },
    },
    loadChildren: () =>
      import('@cardapio-online/financial-admin').then((m) => m.FinancialModule),
  },
  {
    path: 'configuracao',
    data: {
      nav: {
        label: 'Configuração',
        badge: '⚙️',
        order: 11,
        showInMenu: false,
        licenseKey: 'settings',
      },
    },
    loadChildren: () =>
      import('@cardapio-online/settings-admin').then((m) => m.SettingsAdminModule),
  },
      {
        path: '**',
        component: NotFoundComponent,
      },
],
},
  {
    path: '',
    component: ShellLayoutComponent,
    children: [

      {
        path: '',
        loadChildren: () =>
          import('@cardapio-online/produtos').then((m) => m.ProdutosModule),
      },
         {
        path: '**',
        component: NotFoundComponent,
      },
    ],
  },
    
]